<template>
    <div>
        <a-card>

            <a-tabs>
                <a-tab-pane v-for="it in packsList" :key="it.id" :tab="it.alisName">
                    <div class="text-center mb-5">
                        <a-button type="primary" style="width: 200px" v-if="it.signUpState === 1" disabled>已报名</a-button>
                        <a-button type="primary" style="width: 200px" v-if="it.signUpState === 0" @click="onSignPermission(it.id)">立即报名</a-button>
                        <a-button v-if="it.signUpState === 2"  style="width: 200px" >报名已截止</a-button>
                    </div>
                    <table class="fx-form-view">
                        <tr>
                            <th>包组名称</th>
                            <td colspan="3">
                                <B>
                                    {{it.packName}}
                                </B>
                            </td>
                        </tr>

                        <tr>
                            <th>预算金额</th>
                            <td>{{it.preMoney}} 万元</td>

                            <th>报名截止时间</th>
                            <td>{{formatDate(it.signEndDate)}}</td>
                        </tr>

                        <tr>
                            <th>开标时间</th>
                            <td>
                                {{formatDate(it.openTime) }}
                            </td>
                            <th>开标地点</th>
                            <td >
                                {{it.openAddress}}
                            </td>
                        </tr>

                        <tr>
                            <th>投标保证金</th>
                            <td>
                            <span v-if="it.bondMoney">
                                 {{it.bondMoney}} 元
                            </span>
                                <span v-else>
                                    无需缴纳
                                </span>
                            </td>

                            <th> 中标/成交服务费</th>
                            <td>
                                <span v-if="it.zbfwfjnz === '1' && it.dealMoney && it.computeType === '4'">{{it.dealMoney}} &nbsp; 元</span>
                                <span v-else-if="it.zbfwfjnz === '1'  && (it.computeType === '1' || it.computeType === '2' || it.computeType === '3')">
                                    根据中标/{{it.jejs === '0'?'成交':'预算'}}金额计算
                                </span>
                                <span v-else>无需缴纳</span>
                            </td>
                        </tr>
                    </table>

                </a-tab-pane>
            </a-tabs>
        </a-card>
    </div>
</template>

<script>
    import moment from "moment";

    export default {
        name: "PacksInfo",
        components: {},
        created() {
            this.initPacks()
        },
        mounted() {
        },
        props: {
            projectId: {
                type: String,
                required: true
            },
            random: {
                type:String,
                default: '',
                required: false
            },
            tenderType: {
                type:String,
                default: '',
                required: false
            }
        },
        watch: {
            random: {
                immediate: false,
                handler(newValue,oldValue) {
                    if (newValue !== oldValue) {
                        // console.log("has listened data!")
                        this.initPacks()
                    }
                }
            }
        },
        data() {
            return {
                packsList: [],
                columns: [
                    {
                        title: '名称',

                        scopedSlots: { customRender: 'subjectName' }
                    },
                    {
                        title: '规格型号',

                        scopedSlots: { customRender: 'specifications' }
                    },
                    {
                        title: '数量',
                        scopedSlots: { customRender: 'quantity' },

                    },
                    {
                        title: '单位',
                        scopedSlots: { customRender: 'unit' },

                    },
                    {
                        title: '其他要求',
                        scopedSlots: { customRender: 'ask' },

                    },
                    {
                        title: '备注',
                        scopedSlots: { customRender: 'remarks' },

                    }
                ],
            }
        },
        methods: {
            formatDate(value) {
                if (!value){
                    return "未设置时间"
                }
                value = value.replace(new RegExp(/-/gm) ,"/")
                value = moment(new Date(value)).format("YYYY/MM/DD HH:mm")
                return value
            },
            tt() {
                this.random = Math.random()*1000*1000*1000*1000*1000*1000 +""
            },
            initPacks() {
                let that = this
                this.$http.get("/api/v1/supplier/legalBid/getPacksList/" + this.projectId).then(function (res) {
                    if(res.code === 200){
                        that.packsList = res.result
                    }
                });
            },
            showConfirm(value) {
                let that = this
                this.$confirm({
                    title: "提示",
                    content: value,
                    okText: '去认证',
                    cancelText: '取消',
                    onOk() {
                        that.$http.get('/api/v1/supplier/getAccountInfo.json').then(function (res) {
                            that.$router.push({path: '/enterprise/LegalCertificationIndex'});
                            // console.log(res);
                            // if (res.result.supplierType === '1') {
                            //     that.$router.push({path: '/enterprise/NatureAuth'})
                            // }else if (res.result.supplierType === '2') {
                            //     that.$router.push({path: '/enterprise/EnterpriseAuth'});
                            // }
                        });
                    },
                    onCancel() {
                    }
                });
            },
            sign() {
                this.$router.push({path: '/LegalSignIndex?id=' + this.projectId})
            },
            onSignPermission(packId) {
                let that = this
                this.$http.get('/api/v1/supplier/legalsign/legalSignPermission.json?projectId=' + this.projectId+'&packId='+packId).then(function (data) {
                    if (data.code === 100) {
                        that.$error({
                            title: '提示',
                            content: data.msg,
                            okText: '确定',
                            onOk() {
                            }
                        })
                    } else if (data.code === 300) {
                        that.showConfirm(data.msg)
                    }else if(data.code === 301){
                      that.$confirm({
                        title: "提示",
                        content: data.msg,
                        okText: '立即认证',
                        cancelText: '继续报名',
                        onOk() {
                          that.$http.get('/api/v1/supplier/getAccountInfo.json').then(function (res) {
                            that.$router.push({path: '/enterprise/LegalCertificationIndex'});
                          });
                        },
                        onCancel() {
                          that.sign()
                        }
                      });
                    } else if (data.code === 200) {
                        that.sign()
                    }
                })
            },
        }
    }
</script>

<style scoped>
    .fx-form-view th {
        border: 1px solid #e6e6e6;
        background-color: #f7f7f7;
        width: 125px;
    }
    .fx-form-view td {
        border: 1px solid #e6e6e6;
    }
    .fx-form-view{
        table-layout: auto;
    }
</style>
